/**
 * Skeleton de Solicitações do site — header padrão + filtros + lista
 * de pedidos de agendamento.
 */
export default function Loading() {
  return (
    <div className="mx-auto flex max-w-7xl animate-pulse flex-col gap-6">
      {/* PageHeader */}
      <div className="h-[104px] rounded-[20px] bg-slate-200" />

      {/* Filtros de status */}
      <div className="h-11 w-64 rounded-xl border border-slate-200 bg-white" />

      {/* Lista de solicitações */}
      <div className="divide-y divide-slate-100 rounded-xl border border-slate-200 bg-white">
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className="flex items-center gap-4 px-5 py-4">
            <div className="flex-1">
              <div className="h-4 w-52 rounded bg-slate-200" />
              <div className="mt-2 h-3 w-36 rounded bg-slate-100" />
            </div>
            <div className="h-6 w-20 rounded-full bg-slate-100" />
            <div className="hidden h-3 w-24 rounded bg-slate-100 sm:block" />
          </div>
        ))}
      </div>
    </div>
  );
}
